"use strict";

angular.module("customer")
.service("CommunityCarouselService", function($http, $compile, gettextCatalog, appConfig) {
    this.fetchCommunities = function() {
        return $http({
            url: appConfig.API_SERVER + "/catalog/customer/community-filters/list/",
            method: "GET"
        });
    };

    this.getDefaultCommunityValues = function() {
        return [{
            filter: "all",
            name: gettextCatalog.getString("See all"),
            image_path: {
                thumbnail: "assets/Logo.png"
            }
        }];
    };

    this.compile = function(scope, value, slick) {
        scope.community = value;
        scope.slick = slick;
        return $compile("<community-carousel-item class='slick-item-wrap'></community-carousel-item>")(scope);
    };

    this.updateSelectedCommunity = function(selectedCommunity, selectedCommunityId) {
        if (!selectedCommunityId) {
            selectedCommunityId = null;
        }

        return $http({
            method: "PATCH",
            ignoreLoadingBar: true,
            url: appConfig.API_SERVER + "/catalog/customer/community-filters/",
            data: {
                customer_filter: selectedCommunity,
                customer_filter_group: selectedCommunityId
            }
        });
    };

    this.isSelectedFilter = function(selectedValue, value) {
        if (selectedValue.id) {
            return value.id === selectedValue.id;
        }
        else {
            return value.filter === "all";
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/community-carousel/community-carousel.service.js
// module id = 843
// module chunks = 0